import { createContext, useContext, useEffect, useRef } from "react";
import io from "socket.io-client";
import { getHostPrefix, getCookieByHost, getSocketURL, getSessionValue } from "../../../Common/Appcommon";
let socketURL = getSocketURL();
const SOCKET_URL = window.location.origin.includes("localhost")
	? "http://localhost:5000"
	: socketURL;

let socket = null;
let socketType = process.env.REACT_APP_SOCKET_TYPE;
if(socketType === "A"){
	let prefix = getHostPrefix();
	const appid = getCookieByHost(prefix + 'loginappid');
	const currentUserId = getSessionValue('loginuserid');
	let userKey = currentUserId + "_" + appid;
	socket = io.connect(SOCKET_URL, {
		query: { userId: userKey } // Pass user ID as query parameter
	});
}
const SocketContext = createContext();

const useSocketContext = () => useContext(SocketContext);

const SocketProvider = ({ children }) => {
	return (
		<SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
	);
};

export { useSocketContext, SocketProvider, socket };
